import { render } from "./ReservacionesEmpleado.vue?vue&type=template&id=56b0cd3a&scoped=true"
import script from "./ReservacionesEmpleado.vue?vue&type=script&lang=js"
export * from "./ReservacionesEmpleado.vue?vue&type=script&lang=js"

import "./ReservacionesEmpleado.vue?vue&type=style&index=0&id=56b0cd3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b0cd3a"]])

export default __exports__